if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      cartUpdateUnsubscriber = undefined;
      currentVariant = undefined;

      constructor() {
        super();
      }
      
updatePriceDisplay(variant, quantity = 1) {
  // ✅ Always target the REAL price wrapper (your ID is like: price-template--...__main)
  const priceWrapper =
    this.querySelector('[id^="price-"]') ||
    document.querySelector('[id^="price-"]');

  if (!priceWrapper) return;

  // Normalize quantity
  quantity = parseInt(quantity, 10) || 1;

  let basePrice = 0;
  let baseComparePrice = 0;

  if (variant) {
    // Shopify variant prices are in cents
    basePrice = Number(variant.price) || 0;
    baseComparePrice = Number(variant.compare_at_price) || 0;

    // ✅ Keep dataset in sync
    priceWrapper.dataset.regularBase = (basePrice * 1.0).toString();
    priceWrapper.dataset.compareBase = (baseComparePrice * 1.0).toString();
  } else {
    basePrice = parseFloat(priceWrapper.dataset.regularBase) || 0;
    baseComparePrice = parseFloat(priceWrapper.dataset.compareBase) || 0;
  }

  const newPrice = basePrice * quantity;
  const newComparePrice = baseComparePrice * quantity;

  const formattedPrice = window.FoxTheme.Currency.formatMoney(
    newPrice,
    window.FoxTheme.settings.moneyFormat
  );

  const formattedComparePrice = window.FoxTheme.Currency.formatMoney(
    newComparePrice,
    window.FoxTheme.settings.moneyFormat
  );

  // ✅ TARGET THE CORRECT ELEMENTS (Fox/Sleek structure)
  const priceSaleEl =
    priceWrapper.querySelector('.f-price-item--sale') ||
    priceWrapper.querySelector('.f-price__sale .f-price-item--sale');

  const priceRegularEl =
    priceWrapper.querySelector('.f-price__regular .f-price-item--regular') ||
    priceWrapper.querySelector('.f-price-item--regular');

  // ✅ Compare-at lives here in your original code:
  // .f-price__sale > .f-price-item--regular
  let priceCompareEl =
    priceWrapper.querySelector('.f-price__sale .f-price-item--regular') ||
    priceWrapper.querySelector('.f-price__compare .f-price-item--regular');

  const showComparePrice =
    baseComparePrice > basePrice && !window.FoxTheme.settings.hide_compare_at_prices;

  if (showComparePrice) {
    priceWrapper.classList.add('f-price--on-sale');

    // sale price (red)
    if (priceSaleEl) priceSaleEl.innerHTML = formattedPrice;

    // regular container often mirrors sale price depending on CSS
    if (priceRegularEl) priceRegularEl.innerHTML = formattedPrice;

    // compare-at (strikethrough)
    if (!priceCompareEl) {
      const saleWrap = priceWrapper.querySelector('.f-price__sale');
      if (saleWrap) {
        priceCompareEl = document.createElement('span');
        priceCompareEl.className = 'f-price-item f-price-item--regular';
        saleWrap.appendChild(priceCompareEl);
      }
    }

    if (priceCompareEl) priceCompareEl.innerHTML = `<s>${formattedComparePrice}</s>`;
  } else {
    priceWrapper.classList.remove('f-price--on-sale');

    if (priceSaleEl) priceSaleEl.innerHTML = formattedPrice;
    if (priceRegularEl) priceRegularEl.innerHTML = formattedPrice;
    if (priceCompareEl) priceCompareEl.innerHTML = '';
  }
}
syncPriceMarkupFromHtml(htmlDoc) {
  const freshPrice = htmlDoc.querySelector('[id^="price-"]');
  const currentPrice =
    this.querySelector('[id^="price-"]') ||
    document.querySelector('[id^="price-"]');

  if (!freshPrice || !currentPrice) return;

  // Replace markup + classes exactly as theme intended
  currentPrice.innerHTML = freshPrice.innerHTML;
  currentPrice.className = freshPrice.className;

  // Keep dataset values in sync too (important for fallback)
  currentPrice.dataset.regularBase = freshPrice.dataset.regularBase || currentPrice.dataset.regularBase;
  currentPrice.dataset.compareBase = freshPrice.dataset.compareBase || currentPrice.dataset.compareBase;
}



      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.quantitySelector = this.querySelector('.custom-qty-selector');
        if (this.quantitySelector) {
          this.quantitySelector.addEventListener('change', (event) => {
            if (event.target.name === 'quantity') {
              const selectedQuantity = event.target.value;
              // Altijd de actuele variant ophalen
              const currentVariant = this.getSelectedVariant(this);
              this.currentVariant = currentVariant;
              this.updatePriceDisplay(currentVariant, selectedQuantity);
            }
          });
        }
  
        this.initQuantityHandlers();

        // Bij laden van de pagina: juiste variant en hoeveelheid tonen
        this.currentVariant = this.getSelectedVariant(this);
        const selectedQuantity = this.querySelector('.custom-qty-selector input[name="quantity"]:checked')?.value || 1;
        this.updatePriceDisplay(this.currentVariant, selectedQuantity);
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        const viewMode = this.dataset.viewMode || 'main-product';

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage, viewMode)
            : this.handleUpdateProductInfo(productUrl, viewMode),
        });
      }

      handleSwapProduct(productUrl, updateFullPage, viewMode) {
        return (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById('shopify-section-sticky-atc-bar'),
              html.getElementById('shopify-section-sticky-atc-bar'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          this.currentVariant = variant;
        };
      }

      handleUpdateProductInfo(productUrl, viewMode) {
        return (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const variant = this.getSelectedVariant(html);
          this.currentVariant = variant;
 
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateShareUrl(variant?.id);
          this.updateVariantInputs(variant?.id);

              if (!variant) {
            this.setUnavailable();
            return;
          }

          // ✅ Restore exact theme price markup from the freshly-fetched HTML
          this.syncPriceMarkupFromHtml(html);

          const selectedQuantity =
            this.querySelector('.custom-qty-selector input[name="quantity"]:checked')?.value || 1;

          // ✅ Then apply quantity + formatting updates
          this.updatePriceDisplay(variant, selectedQuantity);

          this.updateMedia(variant);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);

            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };



          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Badges', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('PricePerItem', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Volume');

          this.updateQuantityRules(this.sectionId, this.productId, html);
          this.querySelector(`#QuantityRules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#VolumeNote-${this.dataset.section}`)?.classList.remove('hidden');
        };
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      updateVariantInputs(variantId) {
        document
          .querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
          .forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
      }

      updateMedia(variant) {
        const productMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (!productMedia) return;

        const setActiveMedia = () => {
          if (typeof productMedia.setActiveMedia === 'function') {
            productMedia.init();
            productMedia.setActiveMedia(variant);
            return true;
          }
          return false;
        };

        if (!setActiveMedia()) {
          this.timer = setInterval(() => {
            if (setActiveMedia()) {
              clearInterval(this.timer);
            }
          }, 100);
        }
      }

      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(`ProductShare-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${variantId}`);
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = this.decoded(text);
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = this.decoded(FoxTheme.variantStrings.addToCart);
        }

        if (!modifyClass) return;
      }

      decoded(text) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = text;
        return tempDiv.textContent;
      }

      setUnavailable() {
        this.toggleAddButton(true, FoxTheme.variantStrings.unavailable);
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();
        if (!this.hasAttribute('data-original-section')) {
          this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      setQuantityBoundries() {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId,
          },
        });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.productIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart')?.classList.add('btn--loading');

        fetch(`${this.getAttribute('data-url')}?variant=${currentVariantId}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.sectionId, this.productId, parsedHTML);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart')?.classList.remove('btn--loading');
          });
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML,
          },
        });

        this.setQuantityBoundries();
      }
    }
  );
}